export const preprocessImage = (image) => {
  const maxImgSize = 1024; //Max size according to Cockpit -> /module/forms/api/Upload.cfc
  return new Promise((resolve, reject) => {
    console.debug('preprocessImage');
    const canvas = document.createElement('canvas');

    const fileReader = new FileReader();
    //Read the file and save it as an image then draw it on a canvas to reduce size
    fileReader.addEventListener('load', (evt) => {
      const img = new Image();
      img.addEventListener('load', () => {
        //Resize image to reduce size
        let width = img.width;
        let height = img.height;
        if (width > height) {
          if (width > maxImgSize) {
            height *= maxImgSize / width;
            width = maxImgSize;
          }
        } else {
          if (height > maxImgSize) {
            width *= maxImgSize / height;
            height = maxImgSize;
          }
        }
        canvas.width = width;
        canvas.height = height;

        const extension = img.src.split(';')[0].split('/')[1];
        console.debug('image extension', extension);
        canvas.getContext('2d').drawImage(img, 0, 0, width, height);
        // const base64Image = canvas.toDataURL('image/' + extension);
        let base64Image = canvas.toDataURL('image/jpeg', 0.7); // default compression 0.7
        console.debug('base64Image size', base64Image.length);
        if (base64Image.length > 180000) {
          console.debug('image size to big. Decrease quality');
          base64Image = canvas.toDataURL('image/jpeg', 0.5); // default compression 0.7
          console.debug('reduced base64Image size', base64Image.length);
        }
        resolve(base64Image);

        //As I've seen in the FormBuilder.cfc the image in the "data" column is not used
        //to generate the report PDF and neither to show an editable form in the App.
        //+++ New reports do not write the base64 string to the database
        //Therefore we do not need to save it to the database so this code becomes obsolete:
        //  if (this.model[key] === undefined) {
        //    this.$set(this.model, key, [canvas.toDataURL()]);
        //  } else {
        //    this.model[key].push(canvas.toDataURL()); //Reuse Base64 encoded image
        //  }
      });
      img.src = evt.target.result;
    });
    fileReader.readAsDataURL(image);
  });
};
